module.exports = __webpack_public_path__ + "static/media/image_27.9aa8eed6.png";